import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FaStar } from "react-icons/fa6";
import ProAnalyseModal from "../proAnalyseModal";

const TestHeader = ({ testInfo, headerTestItems, footerButtons }: any) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const step = searchParams.get("step");
  const { id } = useParams();

  return (
    <>
      <div className="gap-2 lg:flex hidden">
        {headerTestItems.map((headerItem: any) => (
          <div
            key={headerItem.step}
            onClick={() =>
              navigate(`/test-result/${id}?step=${headerItem.step}`)
            }
            className={`flex-1 ${
              step == headerItem.step ? "bg-white shadow-xl" : "bg-pr_purple"
            } p-4 rounded-lg cursor-pointer duration-300 hover:shadow-xl`}
          >
            <h3 className="font-rokh font-[900] mt-1">{headerItem.title}</h3>
            <p className="text-[13px] font-rokh font-[700] mt-1">
              {headerItem.info}
            </p>
          </div>
        ))}
      </div>

      <div className="block lg:hidden mb-5 -mt-3">{footerButtons}</div>

      {!testInfo?.is_pro_analysis && (
        <div className="fixed bottom-0 left-0 w-full z-[1000] bg-pr_primary px-5 py-3">
          <div className="flex items-center justify-between max-w-sm mx-auto">
            <div className="flex items-center">
              <FaStar size={20} className="text-white ml-3" />
              <p className="text-sm font-rokh font-[700] pt-[5px] text-white w-[150px] lg:w-auto">
                تحلیل پیشرفته این آزمایش رو الان بگیر!
              </p>
            </div>
            <ProAnalyseModal id={id} top="top-2" left="left-20" />
          </div>
        </div>
      )}
    </>
  );
};

export default TestHeader;
